import {
    DataTable,
    AuthContext,
    DataTablePresenter,
    IAuthContextProps, IFilterSchema,
    ITableColumn,
    ITableFetchOptions, ListProviderRefundRequestsRequest, PatientBadge,
    ProviderCollectionRefundRequest, ProviderThinPatient,
    renderAmount,
    renderDateTime, ProviderClaim, FilterMethod, BaseNavLink, BaseButton
} from "@enter/core";
import {
    DataTableCard,
    PageHeader,
    PageLayout,
    PageLayoutHeader,
    PageLayoutRow, PageLayoutTitle,
    ProviderMessagingContext
} from 'components';
import { DialogContext, IDialogContextProps } from 'services';
import * as S from './overpayments.styles';
import {IInjectedRootStore, IObservedRootStore, parseSortBy} from "stores";
import {inject, observer} from "mobx-react";
import React, { useContext } from 'react';
import {NotesDialog} from "../../../components/notes-dialog/notes-dialog";
import {useParams} from "react-router-dom";
import Icon from "@mdi/react";
import {
    mdiCheckboxMarked,
    mdiEmailOutline, mdiEmailSeal,
    mdiEmailArrowRight, mdiInformation,
    mdiLanPending,
    mdiMailboxOpenUpOutline,
    mdiProgressClock
} from "@mdi/js";
import {InboxMail} from "../mail/inbox/inbox";
import {OutboxMail} from "../mail/outbox/outbox";
import {Shipment} from "../mail/shipment/shipment";
import {OverpaymentsPending} from "./overpayments-pending";
import {OverpaymentsApproved} from "./overpayments-approved";
import {OverpaymentsSubmitted} from "./overpayments-submitted";
import {OverpaymentsCompleted} from "./overpayments-completed";
//
// interface IOverpaymentsProps extends IInjectedRootStore {
//     authContext: IAuthContextProps;
//     dialogContext: IDialogContextProps;
// }
//
// interface IOverpaymentsState {
//     loading: boolean;
//     options: ITableFetchOptions | undefined;
// }
//
// const filterSchemas: IFilterSchema<keyof ListProviderRefundRequestsRequest>[] = [];
//
//
// const columnsBase: ITableColumn<ProviderCollectionRefundRequest>[] = [
//     {
//         id: 'RefundAmount',
//         Header: 'Refund Amount',
//         accessor: 'refundAmount',
//         disableSortBy: true,
//         Cell: ({ cell }) => <S.Cell>{renderAmount(cell.value)}</S.Cell>,
//     },
//     {
//         id: 'Patient',
//         Header: 'Patient',
//         accessor: 'patient',
//         disableSortBy: true,
//         Cell: ({ cell }) => <S.Cell>{
//             <PatientBadge
//                 id={(cell.value as ProviderThinPatient).patientId}
//                 first={(cell.value as ProviderThinPatient).first}
//                 last={(cell.value as ProviderThinPatient).last}
//                 suffix={(cell.value as ProviderThinPatient).suffix}
//                 tooltip="View Patient Statement"
//                 path={`/patients/${(cell.value as ProviderThinPatient).patientId}/statement`} />
//         }</S.Cell>,
//     },
//     {
//         id: 'CreateDate',
//         Header: 'Created',
//         accessor: 'created',
//         disableSortBy: true,
//         defaultSort: { id: 'PaymentDate', desc: true },
//         Cell: ({ cell }) => <S.Cell>{renderDateTime(cell.value)}</S.Cell>,
//     },
// ];
//
//
// export const columns: ITableColumn<ProviderCollectionRefundRequest>[] = [
//     ...columnsBase,
//     {
//         id: 'Action',
//         Header: '',
//         disableSortBy: true,
//         Cell: ({ row }): React.ReactElement => {
//             const messagingContext = useContext(ProviderMessagingContext);
//             const dialogContext = useContext(DialogContext);
//
//             const handleApprove = () => {
//                 const handleClose = (): void => {
//                     dialogContext.hideDialog();
//                 };
//
//                 const handleSubmit = (notes?: string): string|undefined => {
//                     console.log("Notes were: ", notes);
//                     dialogContext.hideDialog();
//                     //window.location.reload(); //For now, just reload the screen
//                     return 'Refund Approved';
//                 }
//
//                 dialogContext.showDialog({
//                     props: {
//                         onClose: handleClose,
//                         disableBackdropClick: true,
//                         disableEscapeKeyDown: true,
//                         renderTitle: 'Approve Refund Amount',
//                     },
//                     Component: <NotesDialog
//                         onClose={handleClose}
//                         onSubmit={handleSubmit}
//                     />,
//                 });
//             };
//
//             console.log("row.values=", row.values);
//
//             const handleMessage = () => {
//
//                 const patient = row.values.Patient;
//                 const refundAmount = row.values.RefundAmount;
//
//                 const message = "Patient: " + patient.first + " " + patient.last + " - (" + patient.dob + ")\n"
//                     + "Patient external id: " + patient.externalId + "\n" + "Refund: " + refundAmount.amount + "\n\nConcern:\n";
//
//                 messagingContext.openPanel?.({
//                     isComposeOpen: true,
//                     defaultSubject: 'Concerns about Refund',
//                     defaultBody: message
//                 });
//             };
//
//             return (
//                 <S.ActionButton
//                     id={row.original.id as string}
//                     actions={[
//                         {
//                             label: 'Approve',
//                             onClick: handleApprove,
//                         },
//                         {
//                             label: 'Deny (Message)',
//                             onClick: handleMessage,
//                         },
//                     ]}
//                 />
//             );
//         },
//     },
// ];
//
//
// class OverpaymentsPage extends React.Component<IOverpaymentsProps, IOverpaymentsState> {
//     private presenter: DataTablePresenter<ProviderCollectionRefundRequest>;
//
//     constructor(props: IOverpaymentsProps) {
//         super(props);
//         this.state = {
//             loading: false,
//             options: undefined,
//         };
//         this.presenter = new DataTablePresenter<ProviderCollectionRefundRequest>({
//             name: 'overpayments',
//             data: [],
//             columns,
//             filterSchemas,
//         });
//     }
//
//
//     public componentDidMount(): void {
//         document.title = 'Provider Dashboard - Overpayments';
//     }
//     public componentWillUnmount(): void {
//         this.authContext.cancelGroup('overpayments');
//     }
//
//     public render() {
//         return (
//             <PageLayout>
//                 <PageHeader title="Overpayments" hideDateRange={true} />
//                 <PageLayoutRow expand={true}>
//                     <DataTableCard size="large">
//                         <DataTable presenter={this.presenter} isLoading={this.state.loading} onFetch={this.onFetch} />
//                     </DataTableCard>
//                 </PageLayoutRow>
//             </PageLayout>
//         );
//     }
//
//
//
//     private get authContext(): IAuthContextProps {
//         return this.props.authContext;
//     }
//
//     private get dialogContext(): IDialogContextProps {
//         return this.props.dialogContext;
//     }
//
//
//     private onFetch = async (fetchOptions: ITableFetchOptions): Promise<void> => {
//         try {
//             this.setState({
//                 options: fetchOptions,
//                 loading: true,
//             });
//             this.authContext.cancelGroup('overpayments');
//             this.authContext.setGroup('overpayments');
//
//             const { pageIndex, pageSize, sortBy, validFilters } = fetchOptions;
//             const sortAndOrder = parseSortBy(sortBy, columns);
//             const listing = await this.props.rootStore.overpaymentStore.loadOverpaymentRefundListing({
//                 page: pageIndex,
//                 pageSize,
//                 ...sortAndOrder,
//                 filters: [{filterId: 'filterApproveDate', filterMethod: FilterMethod.EMPTY, filterType: 'String', value: ''}, ...validFilters],
//             });
//             this.presenter.onDataUpdate(listing.items || []);
//             this.presenter.onDataTotalChange(listing.total || 0);
//             this.setState({
//                 loading: false,
//             });
//         } catch (err) {
//             this.dialogContext.showError(err);
//         }
//     };
//
// }
//



export const Overpayments: React.FC<IObservedRootStore> = inject('rootStore')(
    observer((props: IObservedRootStore) => {
        const { rootStore } = props;
        if (!rootStore) {
            return <></>;
        }
        const authContext = useContext(AuthContext);
        const dialogContext = useContext(DialogContext);


        const { tab } = useParams<{ tab: 'pending' | 'approved' | 'submitted' | 'completed'}>();

        return (
            <PageLayout>
                <PageLayoutRow>
                    <PageLayoutHeader>
                        <PageLayoutTitle>Overpayment Refunds</PageLayoutTitle>
                        <S.FlexBreak></S.FlexBreak>
                        <S.SubTitle>These are requests for refunds where the system has determined that the patient has paid more than what their insurance company allows.</S.SubTitle>
                    </PageLayoutHeader>
                </PageLayoutRow>
                <PageLayoutRow>
                    <DataTableCard size="large">
                        <S.TabsContainer>
                            <BaseNavLink to="/overpayments/pending" disabled={tab === 'pending'}>
                                {(linkProps): React.ReactElement => (
                                    <BaseButton variant="outlined" disabled={linkProps.active}>
                                        <Icon path={mdiProgressClock} size={0.75} />
                                        <span>Waiting for Approval</span>
                                    </BaseButton>
                                )}
                            </BaseNavLink>
                            <BaseNavLink to="/overpayments/approved" disabled={tab === 'approved'}>
                                {(linkProps): React.ReactElement => (
                                    <BaseButton variant="outlined" disabled={linkProps.active}>
                                        <Icon path={mdiEmailSeal} size={0.75} />
                                        <span>Approved</span>
                                    </BaseButton>
                                )}
                            </BaseNavLink>
                            <BaseNavLink to="/overpayments/submitted" disabled={tab === 'submitted'}>
                                {(linkProps): React.ReactElement => (
                                    <BaseButton variant="outlined" disabled={linkProps.active}>
                                        <Icon path={mdiEmailArrowRight} size={0.75} />
                                        <span>Submitted</span>
                                    </BaseButton>
                                )}
                            </BaseNavLink>
                            <BaseNavLink to="/overpayments/completed" disabled={tab === 'completed'}>
                                {(linkProps): React.ReactElement => (
                                    <BaseButton variant="outlined" disabled={linkProps.active}>
                                        <Icon path={mdiCheckboxMarked} size={0.75} />
                                        <span>Completed</span>
                                    </BaseButton>
                                )}
                            </BaseNavLink>
                        </S.TabsContainer>
                        <S.HeaderContainer>
                            {tab === 'pending' && <S.SubHeader><Icon path={mdiInformation} size={0.75} /> These are refunds waiting for you to review and approve.</S.SubHeader>}
                            {tab === 'approved' && <S.SubHeader><Icon path={mdiInformation} size={0.75} /> These are approved, but waiting for the automated system to submit. It is still possible to unapprove a refund in this stage.</S.SubHeader>}
                            {tab === 'submitted' && <S.SubHeader><Icon path={mdiInformation} size={0.75} /> These were submitted, but awaiting refund confirmation.</S.SubHeader>}
                            {tab === 'completed' && <S.SubHeader><Icon path={mdiInformation} size={0.75} /> The refund was received and the request was completed.</S.SubHeader>}
                        </S.HeaderContainer>


                        {tab === 'pending' && <OverpaymentsPending />}
                        {tab === 'approved' && <OverpaymentsApproved  />}
                        {tab === 'submitted' && <OverpaymentsSubmitted/> }
                        {tab === 'completed' && <OverpaymentsCompleted/> }
                    </DataTableCard>
                </PageLayoutRow>
            </PageLayout>
        );


    }),
);